/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { opexesRentCopyCreate } from '../fn/opexs-rent/opexes-rent-copy-create';
import { OpexesRentCopyCreate$Params } from '../fn/opexs-rent/opexes-rent-copy-create';
import { opexesRentCreate } from '../fn/opexs-rent/opexes-rent-create';
import { opexesRentCreate$FormData } from '../fn/opexs-rent/opexes-rent-create-form-data';
import { OpexesRentCreate$FormData$Params } from '../fn/opexs-rent/opexes-rent-create-form-data';
import { OpexesRentCreate$Params } from '../fn/opexs-rent/opexes-rent-create';
import { opexesRentCreate$XWwwFormUrlencoded } from '../fn/opexs-rent/opexes-rent-create-x-www-form-urlencoded';
import { OpexesRentCreate$XWwwFormUrlencoded$Params } from '../fn/opexs-rent/opexes-rent-create-x-www-form-urlencoded';
import { opexesRentDestroy } from '../fn/opexs-rent/opexes-rent-destroy';
import { OpexesRentDestroy$Params } from '../fn/opexs-rent/opexes-rent-destroy';
import { opexesRentEnumsRetrieve } from '../fn/opexs-rent/opexes-rent-enums-retrieve';
import { OpexesRentEnumsRetrieve$Params } from '../fn/opexs-rent/opexes-rent-enums-retrieve';
import { opexesRentList } from '../fn/opexs-rent/opexes-rent-list';
import { OpexesRentList$Params } from '../fn/opexs-rent/opexes-rent-list';
import { opexesRentPartialUpdate } from '../fn/opexs-rent/opexes-rent-partial-update';
import { opexesRentPartialUpdate$FormData } from '../fn/opexs-rent/opexes-rent-partial-update-form-data';
import { OpexesRentPartialUpdate$FormData$Params } from '../fn/opexs-rent/opexes-rent-partial-update-form-data';
import { OpexesRentPartialUpdate$Params } from '../fn/opexs-rent/opexes-rent-partial-update';
import { opexesRentPartialUpdate$XWwwFormUrlencoded } from '../fn/opexs-rent/opexes-rent-partial-update-x-www-form-urlencoded';
import { OpexesRentPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-rent/opexes-rent-partial-update-x-www-form-urlencoded';
import { opexesRentRetrieve } from '../fn/opexs-rent/opexes-rent-retrieve';
import { OpexesRentRetrieve$Params } from '../fn/opexs-rent/opexes-rent-retrieve';
import { opexesRentUpdate } from '../fn/opexs-rent/opexes-rent-update';
import { opexesRentUpdate$FormData } from '../fn/opexs-rent/opexes-rent-update-form-data';
import { OpexesRentUpdate$FormData$Params } from '../fn/opexs-rent/opexes-rent-update-form-data';
import { OpexesRentUpdate$Params } from '../fn/opexs-rent/opexes-rent-update';
import { opexesRentUpdate$XWwwFormUrlencoded } from '../fn/opexs-rent/opexes-rent-update-x-www-form-urlencoded';
import { OpexesRentUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-rent/opexes-rent-update-x-www-form-urlencoded';
import { BackendRentDto } from '../models/backend-rent-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiOpexsRentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `opexesRentList()` */
  static readonly OpexesRentListPath = '/api/opexes/rent/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentList$Response(
    params?: OpexesRentList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendRentDto>>> {
    return opexesRentList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentList(params?: OpexesRentList$Params, context?: HttpContext): Observable<Array<BackendRentDto>> {
    return this.opexesRentList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendRentDto>>): Array<BackendRentDto> => r.body),
    );
  }

  /** Path part for operation `opexesRentCreate()` */
  static readonly OpexesRentCreatePath = '/api/opexes/rent/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesRentCreate$Response(
    params: OpexesRentCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesRentCreate(params: OpexesRentCreate$Params, context?: HttpContext): Observable<BackendRentDto> {
    return this.opexesRentCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesRentCreate$XWwwFormUrlencoded$Response(
    params: OpexesRentCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesRentCreate$XWwwFormUrlencoded(
    params: OpexesRentCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendRentDto> {
    return this.opexesRentCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesRentCreate$FormData$Response(
    params: OpexesRentCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesRentCreate$FormData(
    params: OpexesRentCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendRentDto> {
    return this.opexesRentCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /** Path part for operation `opexesRentRetrieve()` */
  static readonly OpexesRentRetrievePath = '/api/opexes/rent/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentRetrieve$Response(
    params: OpexesRentRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentRetrieve(params: OpexesRentRetrieve$Params, context?: HttpContext): Observable<BackendRentDto> {
    return this.opexesRentRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /** Path part for operation `opexesRentUpdate()` */
  static readonly OpexesRentUpdatePath = '/api/opexes/rent/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesRentUpdate$Response(
    params: OpexesRentUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesRentUpdate(params: OpexesRentUpdate$Params, context?: HttpContext): Observable<BackendRentDto> {
    return this.opexesRentUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesRentUpdate$XWwwFormUrlencoded$Response(
    params: OpexesRentUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesRentUpdate$XWwwFormUrlencoded(
    params: OpexesRentUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendRentDto> {
    return this.opexesRentUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesRentUpdate$FormData$Response(
    params: OpexesRentUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesRentUpdate$FormData(
    params: OpexesRentUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendRentDto> {
    return this.opexesRentUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /** Path part for operation `opexesRentDestroy()` */
  static readonly OpexesRentDestroyPath = '/api/opexes/rent/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentDestroy$Response(
    params: OpexesRentDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesRentDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentDestroy(params: OpexesRentDestroy$Params, context?: HttpContext): Observable<void> {
    return this.opexesRentDestroy$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `opexesRentPartialUpdate()` */
  static readonly OpexesRentPartialUpdatePath = '/api/opexes/rent/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesRentPartialUpdate$Response(
    params: OpexesRentPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesRentPartialUpdate(params: OpexesRentPartialUpdate$Params, context?: HttpContext): Observable<BackendRentDto> {
    return this.opexesRentPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesRentPartialUpdate$XWwwFormUrlencoded$Response(
    params: OpexesRentPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesRentPartialUpdate$XWwwFormUrlencoded(
    params: OpexesRentPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendRentDto> {
    return this.opexesRentPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesRentPartialUpdate$FormData$Response(
    params: OpexesRentPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesRentPartialUpdate$FormData(
    params: OpexesRentPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendRentDto> {
    return this.opexesRentPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /** Path part for operation `opexesRentCopyCreate()` */
  static readonly OpexesRentCopyCreatePath = '/api/opexes/rent/{id}/copy/';

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentCopyCreate$Response(
    params: OpexesRentCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRentDto>> {
    return opexesRentCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentCopyCreate(params: OpexesRentCopyCreate$Params, context?: HttpContext): Observable<BackendRentDto> {
    return this.opexesRentCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRentDto>): BackendRentDto => r.body),
    );
  }

  /** Path part for operation `opexesRentEnumsRetrieve()` */
  static readonly OpexesRentEnumsRetrievePath = '/api/opexes/rent/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesRentEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentEnumsRetrieve$Response(
    params: OpexesRentEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesRentEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesRentEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesRentEnumsRetrieve(params: OpexesRentEnumsRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.opexesRentEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
